import MuiRadio from '@material-ui/core/Radio'

const Radio = (props) => (
  <MuiRadio color='primary' disableRipple {...props} />
)

export default Radio